<template>
    <div>
        <label><input type="checkbox" v-model="block.showInNavigation" ref="showInNavigation"> In Navigation anzeigen</label>
        <text-input v-model="block.name" label="Name" ref="name" />
        <long-text-input :value="block.header" label="Header" ref="header"/>
        <long-text-input :value="block.text" label="Text" ref="text"/>
        <div class="admin-info mb-3">
          <h5>An example of how to make an accordion as in the design specification:</h5>
          {{ exampleHTML }}
        </div>

        <div class="form-group">
            <label for="#chapter-position">Titel Position</label>
            <multiselect id="chapter-position" v-model="titlePosition"
                        label="label"
                        :options="titlePositionOptions"
                        :show-labels="false">
            </multiselect>
        </div>
        <file-input v-model="images" label="Bilder" type="image" :max-files="12"/>
        <!--<entity-multiselect
            entity="card"
            label="Karteikarten"
            :value="cardIds"
            @input="changedCards"
            name="cards"
            ></entity-multiselect>-->
        <hr />
        <h2>Karteikarten bearbeiten</h2>
        <CardList :data="blockData" :is-subchapter="false" @cardsChange="changedCards" />
        <hr />
        <button class="btn btn-primary" @click="save">Save</button>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import CardList from "../../pages/admin/synthesis/card/List";

export default {
  props: ["project", "blockData"],
  components: { Multiselect, CardList },
  data() {
    return {
      block: this.blockData,
      images: this.blockData.images.slice(),
      cardIds:
        (this.blockData.cards &&
          this.blockData.cards.length &&
          this.blockData.cards.map(card => card.id)) ||
        [],
      titlePositionValue: this.blockData.titlePosition,
      titlePositionOptions: [
        { value: "left", label: "Links" },
        { value: "right", label: "Rechts" }
      ]
    };
  },
  watch: {
    blockData(newBlock) {
      this.block = newBlock;
      cardIds =
        (newBlock.cards &&
          newBlock.cards.length &&
          newBlock.cards.map(card => card.id)) ||
        [];
      titlePositionValue = newBlock.titlePosition;
    }
  },
  computed: {
    titlePosition: {
      get() {
        return this.titlePositionOptions.find(
          option => option.value === this.titlePositionValue
        );
      },
      set(titlePosition) {
        this.titlePositionValue = titlePosition.value;
      }
    },
    exampleHTML() {
      return `<div class="row">
  <div class="col-12 col-md-10">
    <accordion multiple>
        <accordion-item>
            <span slot="title" class="text-medium">Gesellschaftliche Normen bestimmen Verhalten</span>
            Lorem Ipsum
        </accordion-item>
        <accordion-item>
            <span slot="title" class="text-medium">Breit finanzierte Energieversorgung geniesst hohe Glaubwürdigkeit</span>
            Lorem Ipsum
        </accordion-item>
    </accordion>
  </div>
</div>`;
    }
  },
  methods: {
    changedCards(values) {
      this.cardIds = values.map(card => card.id);
      this.save();
    },
    save() {
      let form = new FormData();
      form.append("edit_resumee_block[titlePosition]", this.titlePositionValue);
      for (let i = 0; i < this.images.length; i++) {
        form.append("edit_resumee_block[images][" + i + "]", this.images[i].id);
      }
      for (let i = 0; i < this.cardIds.length; i++) {
        form.append("edit_resumee_block[cards][" + i + "]", this.cardIds[i]);
      }
      if (this.block.showInNavigation)
        form.append("edit_resumee_block[showInNavigation]", true);
      else form.append("edit_resumee_block[showInNavigation]", false);
      form.append("edit_resumee_block[submit]", null);

      Promise.all([
        this.$refs.name.save(),
        this.$refs.header.save(),
        this.$refs.text.save(),
        axios.post(
          "/api/" + store.state.language + "/block/" + this.block.id + "/edit",
          form
        )
      ]).then(([nameSave, headerSave, textSave, { data }]) => {
        this.block = data.result;
        this.images = data.result.images.slice();
        this.cardIds =
          (data.result.cards &&
            data.result.cards.length &&
            data.result.cards.map(card => card.id)) ||
          [];
        this.titlePositionValue = data.result.titlePosition;
      });
    }
  }
};
</script>

<style scoped>
.admin-info {
  white-space: pre;
}
</style>


// WEBPACK FOOTER //
// src/components/Blocks/ResumeeBlock.vue